import { apiClient } from "@/lib/api/client"
import type { FeatureFlagsResponse } from "../types/feature-flags.types"

export async function getFeatureFlags(): Promise<FeatureFlagsResponse> {
  const { data } = await apiClient.get<FeatureFlagsResponse>(
    "/api/core/feature-flags/",
  )
  return data
}
